import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-sand" aria-labelledby="garantia-titulo" data-id="element-53" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-content flex-col items-start gap-6 px-6 py-14 sm:flex-row sm:items-center sm:gap-10" data-id="element-54" data-mp="1o5zqk0x60943">
        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-sage text-cream" data-id="element-55" data-mp="1x3tp7iiejeuf">
          <ShieldCheckIcon aria-hidden="true" className="h-7 w-7" data-id="element-56" data-mp="19dz8gpuyp64w" />
        </span>
        <div data-id="element-57" data-mp="14g67cb8in2bh">
          <h2 id="garantia-titulo" className="font-display text-2xl font-semibold text-plum" data-id="element-58" data-mp="14gfnz87o7x4i">
            Garantía de satisfacción de 7 días
          </h2>
          <p className="mt-2 max-w-2xl font-sans text-base leading-relaxed text-ink/75" data-id="element-59" data-mp="1edc0rq4lr5ev">
            Si en 7 días sentís que este kit no le aporta estructura y
            profesionalismo a tus sesiones, te devolvemos el 100% de tu dinero.
            Sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}